import m from 'mithril';
import topUpOptions from "./topUpOptions"
import modalCloseButton from '../../../components/modalCloseButton';

const modal = {
  key: 'CARD_SELECTION_MODAL',

  show() {
    $(`#${modal.key}`).modal('show');
  },
  hide() {
    $(`#${modal.key}`).modal('hide');
  },
  oninit({ state }) {
    state.cards = [
      { id: 4, name: 'XXXX-XXXX-XXXX-1234' },
      { id: 5, name: 'XXXX-XXXX-XXXX-5678' },
      { id: 6, name: 'XXXX-XXXX-XXXX-9012' },
      { id: 7, name: 'XXXX-XXXX-XXXX-3456' },
      { id: 8, name: 'XXXX-XXXX-XXXX-7890' },
    ];
    state.selectedCard = null;
  },
  view({ state }) {
    return m('.modal', { id: modal.key },
      [
        m('.modal-dialog.modal-dialog-centered[role="document"]',
          [
            m('.modal-content',
              [
                m('.modal-header',
                  [
                    m('h1.modal-title', 'Select a Card'),
                    m("div", { "class": "btn btn-icon btn-sm btn-active-light-primary ms-2", "data-bs-dismiss": "modal", "aria-label": "Close" },
                      m(modalCloseButton)
                    )
                  ]),
                m('.modal-body',
                  [
                    m('form', [
                      m('div.form-group', [
                        m('label', m('h3', 'Pick a card:')),
                        m('select.form-control', {
                          onchange: (e) => state.selectedCard = e.target.value,
                          value: state.selectedCard,
                          placeholder: 'Tap to select card',
                        },
                          m('option', { value: '' }, 'Tap to select card'),
                          state.cards.map((card) => m('option', { value: card.id }, card.name))
                        ),

                      ]),
                      
                      !state.selectedCard ? null : 
                      [m("br"),
                      m('h3.modal-title', 'Card Information'),
                      m("div", { "class": "table-responsive" },
                        m("table", { "class": "table table-row-dashed table-row-gray-300" },
                          [
                            m("tbody",
                              [
                                m("tr",
                                  [
                                    m("td", m("b", "Name")),
                                    m("td", "Sample Name")
                                  ]
                                ),
                                m("tr",
                                  [
                                    m("td", m("b", "Card Number")),
                                    m("td", "4111 1111 1111 1111")
                                  ]
                                ),
                                m("tr",
                                  [
                                    m("td", m("b", "Cards")),
                                    m("td", "5")
                                  ]
                                ),
                                m("tr",
                                  [
                                    m("td", m("b", "Balance")),
                                    m("td", "$1,000.00")
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      ),
                      m('button.btn.btn-primary[type="button"].w-100', {
                        onclick() {
                          modal.hide();
                          topUpOptions.show()
                        },
                      }, 'Top Up Card')]
                    ]),
                  ]),
              ]),
          ]),
      ]);
  },
};

export default modal;
